export default __webpack_public_path__ + "static/media/THE_MODERN_DAY_QUEEN_compressed.pdf.79a8aa56.png";